<p-toast></p-toast>
<p-card styleClass="p-card-shadow">
  <div class="card dashboardTable">
    <p-toolbar styleClass="mb-4">
      <ng-template pTemplate="left">
        <!-- left template -->
      </ng-template>
      <ng-template pTemplate="right">
        <button (click)="menu.toggle($event)" pButton pRipple label="{{ 'EXPORT' | translate }}" icon="pi pi-upload"
          class="p-button-help"></button>

        <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
      </ng-template>
    </p-toolbar>
    <p-table #dataTable [value]="fsv_lot_report" dataKey="AppId_ProgID" [rows]="10" [paginator]="true"
      [globalFilterFields]="[
        'Lot_No',
        'AppID',
        'ApplicationType',
        'Program_Name',
        'Centre_share_amt',
        'State_share_amt',
        'Subsidy_to_Vendor',
        'CreatedDate',
        'PFMSPaymentDate',
        'Status',
        'Remarks',
        'Fin_Year'
      ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id" currentPageReportTemplate="{{ 'SHOWING' | translate }} {first} {{
        'TO' | translate
      }} {last} {{ 'OF' | translate }} {totalRecords} {{
        'ENTRIES' | translate
      }}" [showCurrentPageReport]="true" [loading]="loading">
      <ng-template pTemplate="caption">
        <div class="flex align-items-center justify-content-between">
          <h5 class="m-0">{{ "STV_LOT_REPORT" | translate }}</h5>
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="
                dataTable.filterGlobal($any($event.target).value, 'contains')
              " placeholder="{{ 'SEARCH' | translate }}" />
          </span>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="Lot_No">
            {{ "LOT_NO" | translate }}
            <p-columnFilter type="text" field="Lot_No" display="menu"></p-columnFilter>
            <p-sortIcon field="Lot_No"></p-sortIcon>
          </th>
          <th pSortableColumn="AppID">
            {{ "APP_ID" | translate }}
            <p-columnFilter type="text" field="AppID" display="menu"></p-columnFilter>
            <p-sortIcon field="AppID"></p-sortIcon>
          </th>
          <th pSortableColumn="ApplicationType">
            {{ "APPLICATION_TYPE" | translate }}
            <p-columnFilter type="text" field="ApplicationType" display="menu"></p-columnFilter>
            <p-sortIcon field="ApplicationType"></p-sortIcon>
          </th>
          <th pSortableColumn="Program_Name">
            {{ "PROGRAM_NAME" | translate }}
            <p-columnFilter type="text" field="Program_Name" display="menu"></p-columnFilter>
            <p-sortIcon field="Program_Name"></p-sortIcon>
          </th>
          <th pSortableColumn="Centre_share_amt">
            {{ "CENTER_SHARE_AMOUNT" | translate }}
            <p-columnFilter type="text" field="Centre_share_amt" display="menu"></p-columnFilter>
            <p-sortIcon field="Centre_share_amt"></p-sortIcon>
          </th>
          <th pSortableColumn="State_share_amt">
            {{ "STATE_SHARE_AMOUNT" | translate }}
            <p-columnFilter type="text" field="State_share_amt" display="menu"></p-columnFilter>
            <p-sortIcon field="State_share_amt"></p-sortIcon>
          </th>
          <th pSortableColumn="Subsidy_to_Vendor">
            {{ "SUBSIDY_TO_VENDOR_AMOUNT" | translate }}
            <p-columnFilter type="text" field="Subsidy_to_Vendor" display="menu"></p-columnFilter>
            <p-sortIcon field="Subsidy_to_Vendor"></p-sortIcon>
          </th>
          <th pSortableColumn="CreatedDate">
            {{ "CREATED_DATE" | translate }}
            <p-columnFilter type="text" field="CreatedDate" display="menu"></p-columnFilter>
            <p-sortIcon field="CreatedDate"></p-sortIcon>
          </th>
          <th pSortableColumn="PFMSPaymentDate">
            {{ "PFMS_PAYMENT_DATE" | translate }}
            <p-columnFilter type="text" field="PFMSPaymentDate" display="menu"></p-columnFilter>
            <p-sortIcon field="PFMSPaymentDate"></p-sortIcon>
          </th>
          <th pSortableColumn="Status">
            {{ "STATUS" | translate }}
            <p-columnFilter type="text" field="Status" display="menu"></p-columnFilter>
            <p-sortIcon field="Status"></p-sortIcon>
          </th>
          <th pSortableColumn="Remarks">
            {{ "REMARKS" | translate }}
            <p-columnFilter type="text" field="Remarks" display="menu"></p-columnFilter>
            <p-sortIcon field="Remarks"></p-sortIcon>
          </th>
          <th pSortableColumn="Fin_Year">
            {{ "FINANCIAL_YEAR" | translate }}
            <p-columnFilter type="text" field="Fin_Year" display="menu"></p-columnFilter>
            <p-sortIcon field="Fin_Year"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-fsv_lot_report>
        <tr>
          <td>{{ fsv_lot_report?.Lot_No }}</td>
          <td>{{ fsv_lot_report?.AppID }}</td>
          <td>{{ fsv_lot_report?.ApplicationType }}</td>
          <td>{{ fsv_lot_report?.Program_Name }}</td>
          <td>{{ fsv_lot_report?.Centre_share_amt }}</td>
          <td>{{ fsv_lot_report?.State_share_amt }}</td>
          <td>{{ fsv_lot_report?.Subsidy_to_Vendor }}</td>
          <td>{{ fsv_lot_report?.CreatedDate | date : "mediumDate" }}</td>
          <td>{{ fsv_lot_report?.PFMSPaymentDate | date : "mediumDate" }}</td>
          <td>{{ fsv_lot_report?.Status }}</td>
          <td>{{ fsv_lot_report?.Remarks }}</td>
          <td>{{ fsv_lot_report?.Fin_Year }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-card>